<script setup>
import { onMounted, ref } from 'vue';
import { __, getInvoices, formatDate, handleDocumentClick } from '@/utils';
import Loader from '@components/loader.vue';
import Table from '@components/table/table.vue';
import documentsFilters from '@components/documentsFilters/documentsFilters.vue'; 

const loader = ref(false);
const invoices = ref(null);
const filteredInvoices = ref(null);

const headings = [
    __('date'),
    __('Type'),
    __('Invoice number'),
    __('The amount to be charged includes VAT'),
    __('action'),
];

onMounted(async () => {
    loader.value = true;
    const [response, error] = await getInvoices();
    if (response?.data) {
        invoices.value = response.data?.data;
        filteredInvoices.value = response.data?.data;
    }
    loader.value = false;
});

const handleDocumentsFiltration = (data) => {
    const { startDate, endDate } = data;
    filteredInvoices.value = invoices.value
        .filter((item) => {
            const documentDate = new Date(item?.invoice_date);
            return documentDate >= startDate && documentDate <= endDate;
        }).sort((a, b) => new Date(b?.invoice_date) - new Date(a?.invoice_date));
};
</script>
<template> 
    <div class="cellular-phone-wrapper cellular-phone-wrapper-invoices">
        <documentsFilters
            :items="filteredInvoices"
            :showSearch="false"
            :btnClass="'btn'"
            :isInvoice="true"
            @filtered="handleDocumentsFiltration"
        />
    </div>
    <div class="invoice-table-header invoice-table-header-gap">
        <p><strong>{{ __('Details of charges') }}</strong></p>
    </div>
    <Loader v-if="loader" color="#2563eb" />
    <Table 
        :headings="headings"
        :items="filteredInvoices"
        v-if="filteredInvoices?.length"
    >
        <template #default="{ item, index }">
            <td>{{ formatDate(item?.invoice_date) }}</td>
            <td>{{ item?.orig_type }}</td>
            <td>{{ item?.invoice_id }}</td>
            <td>{{ item?.amount }}</td>
            <td>
                <a href="#" class="link-icon" target="_blank"  @click.prevent="handleDocumentClick(item?.invoice_id, false)">
                    <img :src="`${theme_path.url}/resources/images/svg/icon-download.svg`" /> 
                    {{ __('Download') }}
                </a>
            </td>
        </template>
    </Table>
</template>